import React from 'react';
import AttendanceCalender from './AttendanceCalender';
import AttendanceTable from './AttendanceTable';


const Attendance = () => {
    const userRole = localStorage.getItem("userRole");

    if (userRole === "Mentor") {
        return (
            <div>
                {/* <AttendanceCalender /> */}
                <AttendanceTable />
            </div>
        );
    }
    else {
        return (
            <div>
                <AttendanceCalender />
            </div>
        )
    }
};

export default Attendance;
